function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "#F2F2F2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0382 24.0989C21.3854 24.0989 24.0989 21.3854 24.0989 18.0381C24.0989 14.6909 21.3854 11.9774 18.0382 11.9774C14.691 11.9774 11.9775 14.6909 11.9775 18.0381C11.9775 21.3854 14.691 24.0989 18.0382 24.0989Z",
  stroke: "#B0B0B0",
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.423 20.1394C16.9082 19.8319 17.4709 19.6686 18.0454 19.6686C18.6199 19.6686 19.1825 19.8319 19.6678 20.1394",
  stroke: "#B0B0B0",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.897 17.4236H20.7541",
  stroke: "#B0B0B0",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1794 17.4236H15.3223",
  stroke: "#B0B0B0",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var SvgMissInfoSmile = function SvgMissInfoSmile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMissInfoSmile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/miss-info-smile.bc1f6fb3.svg";
export { ForwardRef as ReactComponent };